<template>
  <div class="list__action__item" v-if="vbComment">
    <div>
      <div class="avatar-fake margin-right-10 flex-row flex__center">
        <span>{{ buildShortName(vbComment.creatorName) }}</span>
      </div>
    </div>
    <div class="list__action__item--content">
      <div class="flex-row flex__between">
        <p class="name margin-0">
          {{ vbComment.creatorName }}
        </p>
        <div class="time font-size__small">
          <i class="fal fa-clock">
            {{ vbComment.createTime | convertToLabelFilter }}
          </i>
        </div>
      </div>
      <div>
        <!--        <p :class="['action-type flex-row flex__left inline-flex']">-->
        <!--          <slot name="actionName"></slot>-->
        <!--        </p>-->
        <div
          v-if="vbComment.content"
          class="content__message--text content__message--item"
        >
          <el-input
            type="textarea"
            resize="none"
            ref="inputComment"
            autosize
            v-model="vbComment.content"
            disabled
            class="input-display__comment style-fullWidth input-none__border bg__transparent"
          ></el-input>
        </div>

        <history-attachments-template
          v-if="vbAttachments && vbAttachments.length"
          :vbAttachments="vbAttachments"
          @downloadFile="downloadFile"
        >
        </history-attachments-template>
      </div>
    </div>
  </div>
</template>

<script>
  import convertToLabelFilter from "../../../filters/convertToLabelFilter";
  import attachmentService from "../../../services/attachmentService";
  import utils from "../../../services/utils";
  import ActionLogAttachments from "../../doc-in/actionLogAttachments";
  import HistoryAttachmentsTemplate from "./history-attachments-template";

  export default {
    name: "comment-template",
    components: {HistoryAttachmentsTemplate, ActionLogAttachments},
    filters: {
      convertToLabelFilter
    },
    props: ["vbComment"],
    watch: {
      vbComment() {
        this.loadVbAttachments();
      }
    },

    data() {
      return {
        vbAttachments: null
      };
    },

    created() {
      this.loadVbAttachments();
    },

    methods: {
      buildShortName(fullName) {
        return utils.buildShortName(fullName);
      },

      downloadFile({vbAttachment}) {
        this.$emit("downloadFile", {vbAttachment});
      },

      loadVbAttachments() {
        return (this.vbComment
            ? attachmentService
              .findAllByComments([this.vbComment.id], {sort: "createTime,desc"})
              .then(response => response.data)
            : Promise.resolve(null)
        ).then(vbAttachments => (this.vbAttachments = vbAttachments));
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/comment-template.vue